/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
  TableAccountability,
  ShadowTableColumn,
  TableAverage,
  TeamAverageRow,
  StickyTableHead,
  ShadowSummaryColumn,
  ArrowHolderSummary,
  ColumnContainerSummary,
} from './styles';
import { SelectPlayerColumn } from '..';
import { Utils } from '../../utils/api';
import { GoChevronDown, GoChevronUp } from 'react-icons/go';

export default ({
  dataTableContent,
  teamAverage,
  dataCy,
  minWidth,
  filter,
  handleSort,
  sortBy,
  sortOrder,
}: {
  dataTableContent: Array<any>;
  teamAverage: any;
  dataCy?: string;
  minWidth?: string;
  filter: string;
  handleSort: (key: string) => void;
  sortBy: string;
  sortOrder: string;
}) => {
  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [reverse, useReverse] = useState<boolean>(false);
  const sortOptions = [!reverse, changeTable, table];
  const UTILS = new Utils();

  useEffect(() => {
    useTable(dataTableContent);
  }, [dataTableContent]);

  function changeTable(e) {
    useTable([...e]);
  }
  function toggleSortDate(sort, params) {
    const sortOptions = [!reverse, changeTable, table];
    useReverse(!reverse);
    UTILS.SortDate(params, sortOptions);
  }

  function toggleSortString(sort, params) {
    useReverse(!reverse);
    UTILS.SortStrings(params, sortOptions);
  }
  function toggleSortNumber(sort, params) {
    useReverse(!reverse);
    UTILS.HandleSorted(params, sortOptions);
  }
  function sortingTableHead(title: string = '', attr: string, location: Array<string>, sortFunction) {
    return (
      <StickyTableHead topPosition="141px" topPositionResponsive="41px" onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sortBy === attr && sortOrder === 'desc' && <GoChevronDown size={14} />}
            {sortBy === attr && sortOrder === 'asc' && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </StickyTableHead>
    );
  }

  return (
    <TableAccountability data-cy={dataCy} minWidth={minWidth}>
      <thead>
        <tr>
          <StickyTableHead topPosition="100px" topPositionResponsive="0px">
            PLAYERS
          </StickyTableHead>
          <StickyTableHead topPosition="100px" topPositionResponsive="0px" colSpan={2}>
            TOTAL EXAMS
          </StickyTableHead>
          <StickyTableHead topPosition="100px" topPositionResponsive="0px" colSpan={5}>
            FRESH EXAMS
          </StickyTableHead>
          <StickyTableHead topPosition="100px" topPositionResponsive="0px" colSpan={4}>
            POST EXAMS
          </StickyTableHead>
        </tr>
        <tr>
          {sortingTableHead('Name', 'firstName', ['firstName'], handleSort)}
          {sortingTableHead('Last 28 Days', 'totalLast28Days', ['summary', 'totalExamLast28Days'], toggleSortNumber)}
          {sortingTableHead('Overall Total', 'overallTotal', ['summary', 'overallTotal'], toggleSortNumber)}
          {sortingTableHead('Current', 'freshCurrent', ['summary', 'freshCurrent'], toggleSortDate)}
          {sortingTableHead('Next', 'freshNext', ['summary', 'freshNext'], toggleSortDate)}
          {sortingTableHead('Last 7 Days', 'freshLast7Days', ['summary', 'freshLast7Days'], toggleSortNumber)}
          {sortingTableHead('Last 28 Days', 'freshLast28Days', ['summary', 'freshLast28Days'], toggleSortNumber)}
          {sortingTableHead('Total Fresh', 'totalFresh', ['summary', 'totalFresh'], toggleSortNumber)}
          {sortingTableHead('Current', 'postCurrent', ['summary', 'postCurrent'], toggleSortDate)}
          {sortingTableHead('Last 7 Days', 'postLast7Days', ['summary', 'postLast7Days'], toggleSortNumber)}
          {sortingTableHead('Last 28 Days', 'postLast28Days', ['summary', 'postLast28Days'], toggleSortNumber)}
          {sortingTableHead('Total Post', 'totalPost', ['summary', 'totalPost'], toggleSortNumber)}
        </tr>
      </thead>
      <tbody>
        {table.length > 0 && (
          <TeamAverageRow>
            <td>
              <TableAverage>Team Average</TableAverage>
            </td>
            <td>{teamAverage?.exams?.totalLast28DaysAvg || '-'}</td>
            <td>{teamAverage?.exams?.overallTotalAvg || '-'}</td>
            <ShadowSummaryColumn>{'-'}</ShadowSummaryColumn>
            <ShadowSummaryColumn>{'-'}</ShadowSummaryColumn>
            <ShadowSummaryColumn>{teamAverage?.exams?.freshLast7DaysAvg || '-'}</ShadowSummaryColumn>
            <ShadowSummaryColumn>{teamAverage?.exams?.freshLast28DaysAvg || '-'}</ShadowSummaryColumn>
            <ShadowSummaryColumn>{teamAverage?.exams?.freshTotalAvg || '-'}</ShadowSummaryColumn>
            <td>{'-'}</td>
            <td>{teamAverage?.exams?.postLast7DaysAvg || '-'}</td>
            <td>{teamAverage?.exams?.postLast28DaysAvg || '-'}</td>
            <td>{teamAverage?.exams?.postTotalAvg || '-'}</td>
          </TeamAverageRow>
        )}
        {table?.length > 0 ? (
          table
            .filter(el => {
              const playerName: string = el.firstName || '';
              const playerLast: string = el.lastName || '';
              const name = `${playerName} ${playerLast}`;
              return name.toLocaleLowerCase().includes(filter.toLowerCase());
            })
            ?.map((item, index) => {
              return (
                <tr key={index}>
                  <SelectPlayerColumn player={item} />
                  <td>{(item.summary?.totalExamLast28Days !== undefined || item.summary?.totalExamLast28Days !== null) ? item.summary?.totalExamLast28Days : '-'}</td>
                  <td>{(item.summary?.overallTotal !== undefined ||item.summary?.overallTotal !== null) ? item.summary?.overallTotal : '-'}</td>
                  <ShadowTableColumn>
                    {(item.summary?.freshCurrent !== undefined ||item.summary?.freshCurrent !== null) ? item.summary?.freshCurrent : '-'}
                  </ShadowTableColumn>
                  <ShadowTableColumn>{(item.summary?.freshNext !== undefined ||item.summary?.freshNext !== null) ? item.summary?.freshNext : '-'}</ShadowTableColumn>
                  <ShadowTableColumn>
                    {(item.summary?.freshLast7Days !== undefined ||item.summary?.freshLast7Days !== null) ? item.summary?.freshLast7Days : '-'}
                  </ShadowTableColumn>
                  <ShadowTableColumn>
                    {(item.summary?.freshLast28Days !== undefined ||item.summary?.freshLast28Days !== null) ? item.summary?.freshLast28Days : '-'}
                  </ShadowTableColumn>
                  <ShadowTableColumn>{(item.summary?.totalFresh !== undefined ||item.summary?.totalFresh !== null) ? item.summary?.totalFresh : '-'}</ShadowTableColumn>
                  <td>{(item.summary?.postCurrent !== undefined ||item.summary?.postCurrent !== null) ? item.summary?.postCurrent : '-'}</td>
                  <td>{(item.summary?.postLast7Days !== undefined ||item.summary?.postLast7Days !== null) ? item.summary?.postLast7Days : '-'}</td>
                  <td>{(item.summary?.postLast28Days !== undefined ||item.summary?.postLast28Days !== null) ? item.summary?.postLast28Days : '-'}</td>
                  <td>{(item.summary?.totalPost !== undefined ||item.summary?.totalPost !== null) ? item.summary?.totalPost : '-'}</td>
                </tr>
              );
            })
        ) : (
          <tr>
            <td colSpan={12}>No Data</td>
          </tr>
        )}
      </tbody>
    </TableAccountability>
  );
};
